<template>
<div>
  <request-status :request='req.create' />
  <!-- {{step}} | {{activeStepConfig.id}} | {{isSuccess}} -->

  <wiz-layout with-help-text
    v-model='obj'
    :overlay='req.create.loading'
    :loading='req.create.loading'
    :steps='steps'
    :active-step.sync='step'
    :help='help' >

    <template slot='component-type' >
      <v-subheader class='overline' >What type of location is this?</v-subheader>
      <!-- <v-radio-group v-model="obj.type" class='ml-3' > -->
        <v-btn outlined @click.prevent='obj.type="address";step=4' class="mx-3" color="primary" >
          Physical address
        </v-btn>
        <v-btn outlined @click.prevent='obj.type="virtual";step=5' color="primary" >
          Virtual / Online
        </v-btn>
      <!-- </v-radio-group> -->
    </template>

    <!-- preview -->
    <template slot='actions' >
      <v-divider class='mt-15' />
      <v-card-actions class='pb-5' style='min-height:90px;' >

        <v-list dense rounded shaped
          v-if='obj && obj.name && !isSuccess'
          style='position:absolute;margin-top:-32px;'
          :class='{"success lighten-1": isSuccess, "grey lighten-4": !isSuccess}'
          class='elevation-5 pa-0 ml-2' >
          <v-subheader
            style='height:20px;'
            :class='{"success": isSuccess, "grey lighten-2": !isSuccess}'
            class='caption pl-4 py-0 my-0' >
            @{{spaceName}}
            <v-spacer/>
            <v-chip v-if='!isSuccess' x-small outlined label class='ml-4 mr-4' >preview</v-chip>
          </v-subheader>
          <v-divider/>
          <v-list-item >
            <v-list-item-avatar v-if='obj && obj.id' >
              <v-icon>mdi-check-all</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title >
                {{obj.name}}
                <v-chip class='ml-2' color='info' x-small v-if='obj.type' v-text='obj.type' />
              </v-list-item-title>
              <v-list-item-subtitle v-if='addressString' v-text='addressString' />
            </v-list-item-content>
            <v-list-item-action v-if='addressLink' >
              <v-btn icon :href='addressLink' target='_blank' >
                <v-icon>mdi-open-in-new</v-icon>
              </v-btn>
            </v-list-item-action>
            <template v-if='isSuccess' >
              <v-list-item-action v-if='obj && obj.id' >
                <v-btn :to='`/settings/spaces/${spaceId}/locations`' target='_blank' text >
                  Go
                </v-btn>
              </v-list-item-action>
            </template>
            <template v-else>
              <v-list-item-action v-if='obj && obj.id' >
                <v-btn @click='reset' target='_blank' text >
                  Reset
                </v-btn>
              </v-list-item-action>
              <v-list-item-action v-if='canCreate' >
                <v-btn
                  :disabled='!isValid'
                  :loading='req.create.loading'
                  @click='create'
                  color='primary'
                  class='px-5' >
                  <template v-if='obj.id' >Save</template>
                  <template v-else >Create</template>
                </v-btn>
              </v-list-item-action>
            </template>
          </v-list-item>
        </v-list>

        <!-- <v-spacer/> -->
      </v-card-actions>

      <v-subheader class='overline py-0' >
        <v-progress-circular
          v-if="global.request.lookups.loading"
          indeterminate color="amber" width="2" size="20" class="mr-2" />
        Existing locations:</v-subheader>
      <v-card-actions v-if='locations' >
        <location-chip class='mr-2'
          v-for='location in locations' :key='location.id'
          @selected='setLocation(location)'
          :space-id='spaceId' :location-id='location.id' />
      </v-card-actions>

    </template>
  </wiz-layout>

  <!-- S: {{step}} | {{validations}} -->
  <!-- <pre v-text="obj" />
  <pre v-text="payload" /> -->
</div>
</template>
<script>
import WizLayout from '@/components/actions/wizards/CarouselLayout.vue'
import SpacePicker from '@/components/pickers/SpacePicker.vue'
import AddressPicker from '@/components/pickers/AddressPicker.vue'
import SuccessScreen from '@/components/actions/wizards/SuccessScreen.vue'
import LocationChip from '@/components/listitems/LocationChip.vue'

import Vue from 'vue'
import {mapGetters} from 'vuex'

const TYPES = {
  ADDRESSS: 'address',
  VIRTUAL: 'virtual',
}

const STEPS = {
  SERVICE: 1,
  NAME: 2,
  TYPE: 3,
  ADDRESS: 4,
  URL: 5,
  SUCCESS: 6
}

export default {
  name: 'NewLocationWizard',
  components: {
    WizLayout,
    LocationChip
  },
  props: {
    spaceId: { required: false },
    customSuccessSteps: { type: Array, required: false },
    touch: { type: Number, default: 0, required: false },
    value: { type: Object, required: false },
    withHelpText: { type: Boolean, default: false }
  },
  data () {
    return {
      STEPS: STEPS,
      step: 1,
      obj: {},
      req: {
        create: {
          resource: 'ag.spaces',
          extra: 'addresses',
          method: 'post'
        }
      },
      helpTextRead: false
    }
  },
  watch: {
    spaceId: {
      immediate: true,
      handler () {
        if (this.spaceId) {
          Vue.set(this.obj, 'service', this.spaceId)
          this.step = 2
        }
      }
    },
    touch () { this.reset() },
    value: {
      immediate: true,
      handler () {
        if (this.value) {
          window.setTimeout(() => { Vue.set(this, 'obj', this.value) }, 500)
          console.log('location:', this.value)
        }
      }
    },
    requestStatus () {
      if (this.requestStatus === 201 || this.requestStatus === 200) {
        this.$emit('saved', this.req.create.result)
        this.step = STEPS.SUCCESS
        this.init()
      }
    }
  },
  methods: {
    reset () {
      this.obj = {}
      if (this.spaceId) {
        Vue.set(this.obj, 'service', this.spaceId)
        this.step = 2
      } else {
        this.step = 1
      }
    },
    create () {
      this.req.create.data = this.payload
      this.req.create.resourceId = this.obj.service

      this.req.create.method = 'post'
      if (this.obj.id) {
        this.req.create.method = 'patch'
        this.req.create.extra = 'addresses/' + this.obj.id
      } else {
        this.req.create.extra = 'addresses'
      }
      this.$request('save', this.req.create)
    },
    setLocation (location) {
      this.step = 2
      this.obj = location
    }
  },
  computed: {
    ...mapGetters('identity', [
      'getLocationsBySpaceId'
    ]),
    showHelpInformation () {
      if (this.withHelpText && !this.helpTextRead && this.help) {
        return true
      }
      return false
    },
    activeStepConfig () {
      if (this.steps && this.step && this.step > 0) {
        return this.steps[this.step - 1]
      }
      return {}
    },
    isSuccess () {
      return this.activeStepConfig.id === 'successscreen'
    },
    locations () {
      return this.getLocationsBySpaceId(this.spaceId)
    },
    requestStatus () {
      return this.req.create.status
    },
    validations () {
      if (!this.obj) {
        return [
          ['Name is required', STEPS.NAME]
        ]
      }
      let errs = []
      if (this.spaceId) { Vue.set(this.obj, 'service', this.spaceId) }

      if (!this.obj.service) {
        errs.push(['Please choose a space', STEPS.SERVICE])
      }
      if (!this.payload.name) {
        errs.push(['Please name this location', STEPS.NAME])
      }
      if (this.obj.type === TYPES.ADDRESSS && !this.payload.place_id) {
        errs.push(['Please pick an address for this location', STEPS.ADDRESS])
      }
      return errs
    },
    canCreate () {
      if (this.step > 3 && this.step !== STEPS.SUCCESS) { return true }
      return false
    },
    isValid () {
      if (this.validations.length === 0) { return true }
      return false
    },
    addressString () {
      if (this.obj.type === TYPES.ADDRESSS) {
        return this.getObjectPath(this.obj, 'place_data.formatted_address', null)
      }
      if (this.obj.type === TYPES.VIRTUAL) {
        return this.getObjectPath(this.obj, 'url', null)
      }
      return null
    },
    placeId () {
      return this.getObjectPath(this.obj, 'place_data.place_id', null)
    },
    addressLink () {
      if (this.placeId) {
        return `https://www.google.com/maps/place/?q=place_id:${this.placeId}`
      }
      if (this.obj.type === 'virtual') {
        return this.getObjectPath(this.obj, 'url', null)
      }
      return null
    },
    payload () {
      let loc = this.getObjectPath(this.obj, 'place_data.geometry.location', null)
      let lat = null
      let lng = null
      if (loc) {
        lat = loc.lat()
        lng = loc.lng()
      }
      let data = {
        name: this.obj.name,
        address: this.addressString,
        url: this.obj.url,
        is_virtual: (this.obj.type === TYPES.VIRTUAL),
        place_id: this.placeId,
        place_data: this.obj.place_data,
        latitude: lat,
        longitude: lng
      }
      if (this.obj.id) { data.id = this.obj.id }
      return data
    },
    successSteps () {
      if (this.customSuccessSteps) { return this.customSuccessSteps }
      let vm = this
      return [
        {
          text: 'Add another',
          events: { click: () => { vm.reset() } }
        },
        {
          text: 'Done',
          events: { click: () => { this.$emit('close') } }
        }
      ]
    },
    steps () {
      let vm = this
      return [
        {
          id: 'service',
          title: 'Pick a Space',
          subtitle: 'Which Space do you want to add this location to?',
          component: SpacePicker,
          events: {
            input () {
              if (vm.obj && vm.obj.service && vm.step === STEPS.SERVICE) {
                vm.step++
              }
            }
          }
        },
        {
          id: 'name',
          title: 'Give this location a name',
          validator: (step, obj) => { return obj && obj.name && obj.name.length > 1 },
        },
        {
          id: 'type',
          title: 'What type of location is it?'
        },
        {
          id: 'place_data',
          attrs: {
            hint: 'Physical address',
            apiKey: 'AIzaSyDBLqBJhup-u2afKcqqonWzGC-vv_7YpnY'
          },
          component: AddressPicker,
          validator: (step, obj) => { return obj && obj.address },
          allowback: true,
          skipable: false
        },
        {
          id: 'url',
          title: 'Provide a meeting URL',
          hint: '(optional) - leave blank if you are using the Zoom integration',
          validator: () => {
            if (vm.obj && vm.obj.url) { return true }
            return false
          },
          allowback: true,
          skipable: true,
          onback: () => {
            vm.step = STEPS.TYPE
          },
          onnext: () => {
            this.create()
          }
        },
        {
          id: 'successscreen',
          attrs: {
            actions: this.successSteps
          },
          events: {
            close () { vm.$emit('close') }
          },
          validator: () => { return false },
          allowback: false,
          skipable: false,
          component: SuccessScreen
        }
      ]
    },
    help () {
      return {
        title: 'Locations',
        listitems: [
          'This wizard will guide you through creating one or more locations',
          'You can create multiple locations in a space',
          'Locations can be a physical address or a virtual location (for example a Zoom meeting url)',
          'Location information is used on your website, appointment page and notifications to help customers get to your appointments on time',
          'The dashboard will also be able to slice your reports by location'
        ],
        ctaText: 'Let\'s go!'
      }
    }
  }
}
</script>
